import { DownCaretIcon } from '../assets/svgImages';
import { OrderSortProps } from '../interface/interface';

export default function OrderSort(props: OrderSortProps) {
  return (
    <>
      <div className="absolute right-2 top-1/2 tranform -translate-y-1/2 flex items-center">
        <label className="text-grey-500 text-xs mr-3">Sort Orders</label>
        <div className="relative">
          <select
            className="ml-2 rounded text-sm border border-primary-blue-500 bg-none"
            value={props.sortprops.state}
            onChange={props.sortprops.action}
          >
            <option value="ASC">Oldest first</option>
            <option value="DESC">Newest first</option>
          </select>
          <DownCaretIcon className="absolute right-2 top-1/2 transform -translate-y-1/2 w-4" />
        </div>
      </div>
    </>
  );
}
